<style lang="stylus" scoped>
    .sysdialog-line
        width 100%
        display flex
        justify-content center
        user-select none
        .sysdialog
            max-width 320px
            padding 12px
            border-radius 6px
            // background rgba(242, 242, 247, 0.50)
            p
                text-align center
                color var(--text-color-primary-60)
                font-size 11px
                line-height 14px
                word-break break-word
</style>

<template>
    <div class="sysdialog-line">
        <div class="sysdialog">
            <p v-html="str"></p>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component
    export default class SysDialog extends Vue {
        @Prop()
        str;
    }
</script>
